import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import GreenGiftIcon from "../../../assets/icons/green-gift-with-bg.svg";
import CrossGreyIcon from "../../../assets/icons/cross-grey.svg";
import { selectConversation } from "../../../redux/messages/messagesSlice";
import { AppDispatch } from "../../../redux/store";
import { authService, messageService } from "../../../services";
import "./index.less";

interface FreeSubscriptionFanInfoProps {
  creatorUsername?: string;
  creatorId?: string;
  creatorName?: string;
}

const FreeSubscriptionFanInfo: React.FC<FreeSubscriptionFanInfoProps> = ({ creatorUsername, creatorId, creatorName }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [isVisible, setIsVisible] = useState<boolean>(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleBuyCollection = () => {
    if (creatorUsername) {
      localStorage.setItem("activeProfileTab", "collection");
      navigate(`/p/${creatorUsername}?ctc=collection`);
    }
  };

  const handleRequestMedia = async () => {
    if (!creatorId) return;

    const currentUserId = authService.getId();
    const conversation = await messageService.isConversationExist({
      fanId: currentUserId,
      creatorId: creatorId,
    });

    dispatch(selectConversation(conversation));

    navigate(`/fan/requestMedia/${conversation?._id}`, { replace: false });
  };

  if (!isVisible) return null;

  return (
    <div className="free-subscription-fan-info-container">
      <img src={CrossGreyIcon} className="free-subscription-fan-info-close" alt="Close" onClick={handleClose} />
      <div className="free-subscription-fan-info-content">
        <img src={GreenGiftIcon} className="free-subscription-fan-info-icon" alt="Gift" />
        <div className="free-subscription-fan-info-text-container">
          <div className="free-subscription-fan-info-title">{t("free-subscription-fan-info-title")}</div>
          <div className="free-subscription-fan-info-description">{t("free-subscription-fan-info-description", { creatorName })}</div>
        </div>
      </div>
      <div className="free-subscription-fan-info-buttons">
        <button className="free-subscription-fan-info-button" onClick={handleBuyCollection}>
          {t("buy-collection")}
        </button>
        <button className="free-subscription-fan-info-button" onClick={handleRequestMedia}>
          {t("request-private-media")}
        </button>
      </div>
    </div>
  );
};

export default FreeSubscriptionFanInfo;
